// Models (Internal)
import { NotesByContractRequest } from '@/api/models/BaseRequest';
import { Notes } from '@/api/models/Notes';

// External Libraries
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * Interface defining the shape of NotesState.
 */
export interface NotesState {
  notes: Notes[] | [];
  loading: boolean;
  error: string | null;
}

// Initial state
const initialState: NotesState = {
  notes: [],
  loading: false,
  error: null,
};

// Create a slice
const notesSlice = createSlice({
  name: 'notes',
  initialState,
  reducers: {
    fetchNotesStart(state, _action: PayloadAction<NotesByContractRequest>) {
      state.loading = true;
      state.error = null;
    },
    fetchNotesSuccess(state, action: PayloadAction<Notes[]>) {
      state.loading = false;
      state.notes = action.payload;
    },
    fetchNotesFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

// Export actions
export const { fetchNotesStart, fetchNotesSuccess, fetchNotesFailure } = notesSlice.actions;

// Export reducer to be added to the store
export default notesSlice.reducer;
